import { CustomCheckbox } from 'Components';

interface IOptions {
  value: string | boolean;
  label: string;
}

interface ICheckboxGroup {
  name: string;
  values: string[];
  options: IOptions[];
  onClick?: Function;
}

export const CheckboxGroup = ({
  name,
  values,
  options,
  onClick,
}: ICheckboxGroup) => {
  const checkboxClickSpecialHandler = (value: string) =>
    onClick ? onClick(value) : undefined;

  return (
    <>
      {options.map(({ value, label }, index: number) => (
        <CustomCheckbox
          key={index}
          name={`${name}.${values[index]}`}
          label={label}
          onClick={checkboxClickSpecialHandler}
        />
      ))}
    </>
  );
};
